import {
  Home,
  About,
  // Products,
  ProductDetail,
  Portfolio,
  PortfolioDetail,
  Board,
  BoardDetail,
  Releases,
  // Golf,
  ProductCategoryPage,
  EnHome,
  EnAbout,
  // EnProducts,
  EnProductDetail,
  EnPortfolio,
  EnPortfolioDetail,
  EnBoard,
  EnBoardDetail,
  EnReleases,
  // EnGolf,
  EnProductCategoryPage,
} from "../components/pages";
import Layout from "../components/common/Layout";
import { LanguageProvider } from "../contexts/LanguageContext";
import { createBrowserRouter, Navigate } from "react-router-dom";

const LayoutWithLanguageProvider = () => (
  <LanguageProvider>
    <Layout />
  </LanguageProvider>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutWithLanguageProvider />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "about",
        element: <Navigate to="/about/greeting" replace />,
      },
      {
        path: "about/:tab",
        element: <About />,
      },
      {
        path: "products",
        element: <Navigate to="/products/shredder" replace />,
      },
      {
        path: "products/:category",
        element: <ProductCategoryPage />,
      },
      {
        path: "products/:category/:productId",
        element: <ProductDetail />,
      },
      {
        path: "portfolio",
        element: <Portfolio />,
      },
      {
        path: "portfolio/:id",
        element: <PortfolioDetail />,
      },
      {
        path: "board",
        element: <Navigate to="/board/contact" replace />,
      },
      {
        path: "board/:tab",
        element: <Board />,
      },
      {
        path: "board/notice/:id",
        element: <BoardDetail />,
      },
      {
        path: "releases",
        element: <Releases />,
      },
      // {
      //   path: "products/golf",
      //   element: <Golf />,
      // },
      {
        path: "/en/",
        element: <EnHome />,
      },
      {
        path: "/en/about",
        element: <Navigate to="/en/about/greeting" replace />,
      },
      {
        path: "/en/about/:tab",
        element: <EnAbout />,
      },
      {
        path: "/en/products",
        element: <Navigate to="/en/products/shredder" replace />,
      },
      {
        path: "/en/products/:category",
        element: <EnProductCategoryPage />,
      },
      {
        path: "/en/products/:category/:productId",
        element: <EnProductDetail />,
      },
      {
        path: "/en/portfolio",
        element: <EnPortfolio />,
      },
      {
        path: "/en/portfolio/:id",
        element: <EnPortfolioDetail />,
      },
      {
        path: "/en/board",
        element: <Navigate to="/en/board/contact" replace />,
      },
      {
        path: "/en/board/:tab",
        element: <EnBoard />,
      },
      {
        path: "/en/board/notice/:id",
        element: <EnBoardDetail />,
      },
      {
        path: "/en/releases",
        element: <EnReleases />,
      },
      // {
      //   path: "/en/products/golf",
      //   element: <EnGolf />,
      // },
      {
        path: "/en/*",
        element: <Navigate to="/en/" />,
      },
      {
        path: "*",
        element: <Navigate to="/" />,
      },
    ],
  },
]);

export default router;
